import React from 'react';

class Capitalize extends React.PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            unit: [$st('元'), $st('万'), $st('亿'), $st('paas.omen')],
            numberUnit: ['', $st('拾'), $st('佰'), $st('仟')],
            numberCase: ['', $st('壹'), $st('贰'), $st('叁'), $st('肆'), $st('伍'), $st('陆'), $st('柒'), $st('捌'), $st('玖')],
            decimalUnit: [$st('角'), $st('分')]
        };
      }
    upperCase = (value)=>{
        //$st( 按照小数划分)
        let values = value.split('.');
        let numbers = (values[0] && values[0].split('')) || [];
        let decimals = values[1] && values[1].split('');
        let minus = '';
        numbers = numbers.reverse();
        
        if (numbers.indexOf('-') != -1) {
            minus = $st('负');
            numbers.pop();
        }
        
        let tails = [],me = this;
        if (decimals){
            tails = decimals.map((num, index)=>{
                if (index < 2){
                    return me.state.numberCase[num] + (num !== '0' ?  me.state.decimalUnit[index]: '');
                }else{
                    return ''
                }
            })
        }else{
            tails.push($st(`整`));
        }
        let uppers = numbers.map((num, index)=>{
            let numberUnitIndex = index % 4;
            let indexNum = parseInt(num, 10);
            return me.state.numberCase[indexNum] + (numberUnitIndex ? (indexNum ? me.state.numberUnit[numberUnitIndex] : '' ): me.state.unit[index/4]);
        });
        return minus + uppers.reverse().join('') + tails.join('');
    }
    roundMode= (value="")=>{
        let values = value.split('.');
        let numbers = (values[0] && values[0].split('')) || [];
        
        let index = numbers.length - 3;
        
        for (; index > 0; index = index - 3){
            numbers.splice(index, 0 , ',');
        }
        let tail = ''
        if (values[1]){
            tail = `.${values[1]}`;
        }
        return numbers.join('') + tail;
    }
    render(){
        let {className, value}= this.props;
        
        return (
            value ? (<div className={className}>{this.upperCase(value)}</div>) : null
        )
    }
}
export default Capitalize;




// WEBPACK FOOTER //
// ./src/component/Number/Capitalize.js